import { render, staticRenderFns } from "./Companies.create.vue?vue&type=template&id=f8f081c0&"
import script from "./Companies.create.vue?vue&type=script&lang=js&"
export * from "./Companies.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports